export default __webpack_public_path__ + "static/media/home1.78e859bf.jpg";